import {
  FaLaptopCode,
  FaNetworkWired,
  FaChartLine,
  FaShopify,
  FaVideo,
} from "react-icons/fa";

const services = [
  {
    title: "Websites From Scratch",
    bestFor: "Best for: service businesses, creators, and startups",
    description:
      "Clean, responsive websites built around your offer, calls to action, and customer journey instead of just pages that look good.",
    deliverable:
      "You get: a polished site structure, responsive UI, and launch-ready frontend.",
    icon: FaLaptopCode,
  },
  {
    title: "Automation Dashboard",
    bestFor: "Best for: agencies and teams managing client workflows",
    description:
      "A central place to track automation activity across clients and platforms so execution data is easier to monitor, explain, and act on.",
    deliverable: "You get: client visibility, workflow status, and cleaner reporting.",
    icon: FaNetworkWired,
  },
  {
    title: "Business Analytics Dashboard",
    bestFor: "Best for: online stores and data-driven companies",
    description:
      "A live dashboard that brings important business metrics from platforms like Google Cloud, Google Ads, Meta Ads, and ecommerce tools into one clear view.",
    deliverable:
      "You get: cross-platform KPI tracking, cleaner reporting, and faster decisions without jumping between tabs.",
    icon: FaChartLine,
  },
  {
    title: "Ecommerce Development",
    bestFor: "Best for: online stores and product-based businesses",
    description:
      "Storefront and backend support across Shopify, Printify, GoHighLevel, and related tools, from product setup to conversion-focused improvements.",
    deliverable:
      "You get: storefront updates, integrations, and practical technical upkeep.",
    icon: FaShopify,
  },
  {
    title: "Video Editing",
    bestFor: "Best for: podcasts, educators, and content-led brands",
    description:
      "AI-assisted editing that turns long-form conversations into sharp, platform-ready clips faster, with cleaner pacing, useful cuts, and stronger short-form structure.",
    deliverable:
      "You get: efficient clip production built for retention, repurposing, and consistent content output.",
    icon: FaVideo,
  },
];

export default function Services() {
  return (
    <section id="services">
      <div className="services__row">
        <div className="services__intro">
          <h1
            className="services__title"
            data-aos="fade-up"
            data-aos-anchor-placement="center-bottom"
          >
            Services
          </h1>
          <p
            className="services__desc"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-anchor-placement="center-bottom"
          >
            Practical technical work for founders, owners, and teams who need
            websites, dashboards, ecommerce systems, or content support that
            makes the business easier to run and easier to sell.
          </p>
          <ul
            className="services__principles"
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-anchor-placement="center-bottom"
          >
            <li>Clearer operations</li>
            <li>Faster execution</li>
            <li>Revenue-aware systems</li>
          </ul>
        </div>

        <ul className="services__list">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <li
                className="service"
                key={service.title}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                data-aos-anchor-placement="bottom-bottom"
              >
                <div className="service__icon">
                  <Icon color="white" size={28} />
                </div>
                <div className="service__content">
                  <p className="service__fit">{service.bestFor}</p>
                  <h2 className="service__title">{service.title}</h2>
                  <p className="service__desc">{service.description}</p>
                  <p className="service__deliverable">{service.deliverable}</p>
                </div>
              </li>
            );
          })}
        </ul>

        <div
          className="services__cta"
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
        >
          <p className="services__cta-copy">
            Have a business bottleneck already? Tell me what you want to build,
            automate, measure, or improve.
          </p>
          <a href="#contact-section" className="services__cta-link">
            Discuss a Project
          </a>
        </div>
      </div>
    </section>
  );
}
